import React, { useState } from "react";
import Card from "components/card";
import {
    Check
} from "lucide-react";

const employees = [
    { id: 1, name: "Ashley Palma", role: "Senior Developer", initials: "AP" },
    { id: 2, name: "Saccharine Elupre", role: "Marketing Manager", initials: "SE" },
    { id: 3, name: "Emily Rodriguez", role: "Frontend Developer", initials: "ER" },
    { id: 4, name: "James Wilson", role: "HR Specialist", initials: "JW" },
    { id: 5, name: "Lisa Anderson", role: "Financial Analyst", initials: "LA" },
    { id: 6, name: "David Martinez", role: "DevOps Engineer", initials: "DM" },
    { id: 7, name: "Jennifer Lee", role: "UX Designer", initials: "JL" },
    { id: 8, name: "Robert Taylor", role: "Sales Director", initials: "RT" },
    { id: 9, name: "Acee Cayanan", role: "Creative Director", initials: "AC" },
    { id: 10, name: "Chris Brown", role: "Backend Developer", initials: "CB" },
    { id: 11, name: "Sarah Johnson", role: "Product Manager", initials: "SJ" },
    { id: 12, name: "Michael Chen", role: "QA Engineer", initials: "MC" },
];

const RecipientGrid = ({ selectedRecipient, setSelectedRecipient }) => {
    const [selectedId, setSelectedId] = useState("");

    return (
        <div className="max-h-[29vh] overflow-y-auto pr-2">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 min-w-full">
                {employees.map((emp) => {
                    const selected = selectedRecipient?.id === emp.id;

                    return (
                        <Card
                            key={emp.id}
                            onClick={() => setSelectedRecipient(emp)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === "Enter" && setSelectedRecipient(emp)}
                            className={`relative cursor-pointer transition-all hover:shadow-md flex flex-col rounded-xl items-center text-center gap-2
                                ${selected
                                ? "border-2 border-emerald-600 bg-emerald-50 dark:border-emerald-400 dark:bg-emerald-900"
                                : "border border-gray-200 hover:border-emerald-300"}`}
                        >
                            <div className="pb-6 p-3">
                                <div className="flex flex-col items-center text-center gap-2">
                                    <div
                                        className={`relative flex overflow-hidden items-center justify-center h-12 w-12 rounded-full text-[14px] font-medium
                                        ${selected ? "bg-emerald-600 text-white" : "bg-gray-200 text-slate-700"}`}
                                    >
                                        {emp.initials}
                                    </div>

                                    <div className="flex-1">
                                       <p className="font-medium text-[12px] line-clamp-1">{emp.name}</p>
                                        <p className="text-[10px] muted-text line-clamp-1">{emp.role}</p>
                                    </div>
                                </div>
                            </div>

                            {selected && (
                                <div className="absolute top-2 right-2 text-emerald-600 dark:text-emerald-500">
                                <Check className="w-4 h-4" />
                                </div>
                            )}
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};
export default RecipientGrid;